import { render, staticRenderFns } from "./PopupProofread.vue?vue&type=template&id=90705774&"
import script from "./PopupProofread.vue?vue&type=script&lang=js&"
export * from "./PopupProofread.vue?vue&type=script&lang=js&"
import style0 from "./PopupProofread.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports